import {WithSeparator, Divider} from '@genestack/ui';
import React from 'react';

import {
    editedOntologyBrowserSource,
    exploredOntologyBrowserSource,
    FindUsagesEditorEvent
} from '../../../../../../webeditor/biokb-editor-adapters';
import {BelEditorWrapper} from '../../../../../components/editor';
import {BrowserTabTitle} from '../../../../../components/window-title/browser-tab-title';
import {EditorBackdrop} from '../../../edit-view/editor/editor-backdrop';

import {NodeViewTree} from './node-view-tree';
import styles from './node-view.module.css';
import {OntologyElement} from '../requests/use-ontology-element-query';

interface Props {
    mode: 'explore' | 'edit';
    documentInfo: EditModeDoc | ViewModeDoc;
    versionId?: number | null;
    nodeId: string;
    onNavigate: (accession: string | null, nodeId: string | null) => void;
    onFindUsages: (event: FindUsagesEditorEvent) => void;
    nodeInfo: OntologyElement;
}

function ontologyBrowserSource(
    accession: string,
    nodeId: string,
    versionId?: number | null,
    nodeContent?: string
) {
    if (nodeContent) {
        return versionId
            ? exploredOntologyBrowserSource(accession, versionId, nodeId, nodeContent)
            : editedOntologyBrowserSource(accession, nodeId, nodeContent);
    }
}

export function NodeView(props: Props) {
    const [isLoadingEditor, setIsLoadingEditor] = React.useState(false);

    const handleNavigate = React.useCallback((nodeId: string) => {
        props.onNavigate(null, nodeId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <BrowserTabTitle text={`${props.documentInfo.name} / ${props.nodeInfo.name}`}>
            <div className={styles.editor} data-testid="node-view">
                <BelEditorWrapper
                    className={styles.editor}
                    documentSource={ontologyBrowserSource(
                        props.documentInfo.accession,
                        props.nodeId,
                        props.versionId,
                        props.nodeInfo.content
                    )}
                    onNavigate={props.onNavigate}
                    onFindUsages={props.onFindUsages}
                    onLoadingStateChange={setIsLoadingEditor}
                />

                <EditorBackdrop isDocumentLoading={isLoadingEditor} />
            </div>

            {props.mode === 'explore' && (
                <React.Fragment>
                    <Divider variant="transparent" gap={2} />

                    <WithSeparator separator={<Divider variant="transparent" gap={2} />}>
                        <div className={styles.root}>
                            {props.nodeInfo.tree.roots.map((item) => (
                                <NodeViewTree
                                    key={item.elementId}
                                    docAccession={props.documentInfo.accession}
                                    data={item}
                                    onNavigate={handleNavigate}
                                />
                            ))}
                        </div>
                    </WithSeparator>
                </React.Fragment>
            )}
        </BrowserTabTitle>
    );
}
